import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";
import Navbar from '../components/Navbar';
import AFBList from "./AFB/AFBList";
import AddAFB from "./AFB/AddAFB";
import Artilelist from '../articlecontent/ArticleList.jsx';
import ArticleHome from '../articlecontent/ArticleHomePage';
import FormikArticle from '../articlecontent/AddArticle';
import Trivialist from '../articlecontent/Trivialist';
import TriviaService from './Trivia/AddTrivia';
import CategoryList from '../articlecontent/CategoryList';
import TopicsList from '../articlecontent/TopicsList';
import MeditationList from './Meditation/MeditationList';
import AddMeditation from './Meditation/AddMeditation';
import CurriculumList from './Curriculum/CurriculumList';
import AddCurriculum from './Curriculum/AddCurriculum';

class LoadData extends React.Component {
        constructor(props) {
          super(props);

        }
    componentDidMount = async () => {
        let response = await this.props.authenticatedApiCall('get', '/api/content/contentservice/getusername');
            if (response.status === 200) {
              this.props.currentUser.changeUser({
                ...this.props.loggedInUserObj.userDetails,
                email: response.data.nameId
            });
            }
    };
    render(){
    return (
        <>
            <Navbar />
            <Switch>
                <Route exact path={`${this.props.match.url}/Article`} component={Artilelist} />
                <Route path={`${this.props.match.url}/Article/Edit`} component={FormikArticle} />
                <Route path={`${this.props.match.url}/Article/New`} component={FormikArticle} />
                <Route path={`${this.props.match.url}/Article/Video`} component={FormikArticle} />
                <Route exact path={`${this.props.match.url}/Trivia`} component={Trivialist} />
                <Route path={`${this.props.match.url}/Trivia/Edit`} component={TriviaService} />
                <Route path={`${this.props.match.url}/Trivia/New`} component={TriviaService} />
                <Route path={`${this.props.match.url}/CategoryList`} component={CategoryList} />
                <Route path={`${this.props.match.url}/TopicsList`} component={TopicsList} />
                <Route exact path={`${this.props.match.url}/Meditation`} component={MeditationList} />
                <Route path={`${this.props.match.url}/Meditation/Edit`} component={AddMeditation} />
                <Route path={`${this.props.match.url}/Meditation/New`} component={AddMeditation} />
                <Route exact path={`${this.props.match.url}/Curriculum`} component={CurriculumList} />
                <Route path={`${this.props.match.url}/Curriculum/Edit`} component={AddCurriculum} />
                <Route path={`${this.props.match.url}/Curriculum/New`} component={AddCurriculum} />
                <Route path={`${this.props.match.url}/AFB/Edit`} component={AddAFB} />
                <Route path={`${this.props.match.url}/AFB/New`} component={AddAFB} />
                <Route exact path={`${this.props.match.url}/AFB`} component={AFBList} />
                <Route path={`${this.props.match.url}`} component={ArticleHome} />
                <Redirect to={`${this.props.match.url}`} />
            </Switch>
        </>
    )}
};

export default AuthenticatedPage()(LoadData);